import api from '../lib/api';

export const FETCH_ALL_FIELD_REPORTS = 'FETCH_ALL_FIELD_REPORTS';
export const FETCH_MARKET_FIELD_REPORTS = 'FETCH_MARKET_FIELD_REPORTS';
export const IS_LOADING = 'IS_LOADING';

export default {
  fetchFieldReports(query) {
    return (dispatch) => {
      dispatch({ type: IS_LOADING, payload: true });

      return api.getFieldReports(query)
        .then((reports) => {
          if (query) {
            dispatch({ type: FETCH_MARKET_FIELD_REPORTS, payload: reports });
          } else {
            dispatch({ type: FETCH_ALL_FIELD_REPORTS, payload: reports });
          }
        })
        .then(() => {
          dispatch({ type: IS_LOADING, payload: false });
        })
        .catch(() => {
          dispatch({ type: IS_LOADING, payload: false });
        });
    };
  },
  updateFieldReport(fieldReport, fieldReportId) {
    return () => api.updateFieldReport(fieldReport, fieldReportId);
  },
  bulkUpdateFieldReportStatus(arrayOfFieldReportIds) {
    return () => api.bulkUpdateFieldReportStatus(arrayOfFieldReportIds);
  },
};
